module.exports = __webpack_public_path__ + "media/images/ibuy-23b7f608372a0a0df0399e8809e183e8.svg";